/**
 * 可检索孪生:supernova 解析器不认幻灯片/老 Office 格式(ppt/pptx/
 * doc/xls/odp——「不可检索」徽标是诚实的),但 school-backend 的
 * soffice 预览转换链路现成(/api/school/documents/preview,office→PDF,
 * 文本层保留)。上传这类文件进知识库时顺手生成一份同名 .pdf 孪生
 * 一起入库:原件保留下载/预览,PDF 负责被检索——与 mhtml→html 镜像
 * 同一套路(Jarod 2026-08-26 PPT 不可检索反馈)。
 *
 * 失败(soffice 超时/坏文件)返回 null,不影响原件上传。
 */
import { authHeaders } from "../api/school";

const CONVERTIBLE_EXTS = new Set(["ppt", "pptx", "doc", "xls", "odp"]);

export function needsSearchableTwin(filename: string): boolean {
  const ext = filename.split(".").pop()?.toLowerCase() ?? "";
  return CONVERTIBLE_EXTS.has(ext);
}

export async function searchableTwinOf(file: File): Promise<File | null> {
  if (!needsSearchableTwin(file.name)) return null;
  try {
    const fd = new FormData();
    fd.append("file", file, file.name);
    const r = await fetch("/api/school/documents/preview", {
      method: "POST",
      headers: authHeaders(), // FormData 自带 boundary
      body: fd,
    });
    if (!r.ok) return null;
    const pdf = await r.blob();
    if (pdf.size === 0) return null;
    const base = file.name.replace(/\.[^.]+$/, "");
    return new File([pdf], `${base}.pdf`, { type: "application/pdf" });
  } catch {
    return null;
  }
}
